import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

const SobrePage = () => {
  const [hero, setHero] = useState<any>(null);
  const [missao, setMissao] = useState<any>(null);
  const [valores, setValores] = useState<any>(null);
  const [historia, setHistoria] = useState<any>(null);
  const [estatisticas, setEstatisticas] = useState<any>(null);

  useEffect(() => {
    carregarConteudo();
  }, []);

  const carregarConteudo = async () => {
    const { data } = await supabase
      .from('conteudo_sobre')
      .select('*');

    if (data) {
      data.forEach((item: any) => {
        if (item.secao === 'hero') setHero(item);
        if (item.secao === 'missao') setMissao(item);
        if (item.secao === 'valores') setValores(item);
        if (item.secao === 'historia') setHistoria(item);
        if (item.secao === 'estatisticas') setEstatisticas(item);
      });
    }
  };

  return (
    <div className="min-h-screen bg-luxury-black">
      <Header />

      <main className="pt-32 pb-24">
        {/* Hero */}
        <section className="px-8 lg:px-20 mb-24">
          <div className="text-center animate-fade-in">
            <h1 className="text-white text-5xl lg:text-7xl font-serif font-bold mb-6">
              Sobre a <span className="bg-gradient-gold bg-clip-text text-transparent">Dindimcast</span>
            </h1>
            <p className="text-gray-400 text-lg lg:text-xl max-w-3xl mx-auto">
              {hero?.subtitulo || 'Educação de Qualidade ao Seu Alcance'}
            </p>
            <p className="text-gray-500 text-base max-w-4xl mx-auto mt-4">
              {hero?.descricao || 'Fundada em 2025, somos uma plataforma dedicada a transformar vidas através da educação digital. Oferecemos cursos e e-books premium criados por especialistas para ajudá-lo a alcançar os seus objetivos profissionais.'}
            </p>
          </div>
        </section>

        {/* Missão */}
        {missao && (
          <section className="px-8 lg:px-20 mb-24">
            <div className="max-w-4xl mx-auto text-center animate-slide-in-left">
              <h2 className="text-luxury-gold text-4xl lg:text-5xl font-serif font-bold mb-6">
                {missao.titulo}
              </h2>
              <p className="text-gray-400 text-base leading-relaxed">
                {missao.descricao}
              </p>
            </div>
          </section>
        )}

        {/* Valores */}
        {valores && (
          <section className="px-8 lg:px-20 mb-24 bg-gradient-dark py-20 -mx-8 lg:-mx-20">
            <div className="px-8 lg:px-20">
              <h2 className="text-white text-4xl lg:text-5xl font-serif font-bold text-center mb-16 animate-fade-in">
                <span className="text-luxury-gold">{valores.titulo || 'Os Nossos Valores'}</span>
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {valores.dados_json?.items?.map((valor: any, index: number) => (
                  <div
                    key={index}
                    className="bg-luxury-black border border-luxury-gold/20 rounded-2xl p-8 hover:border-luxury-gold transition-all duration-300 hover:shadow-gold animate-fade-in-up"
                    style={{ animationDelay: `${index * 200}ms` }}
                  >
                    <div className="w-16 h-16 bg-gradient-gold rounded-xl flex items-center justify-center mb-6">
                      <i className={`${valor.icone} text-black text-3xl`}></i>
                    </div>
                    <h3 className="text-luxury-gold text-2xl font-bold mb-4">
                      {valor.titulo}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {valor.descricao}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* História */}
        {historia && (
          <section className="px-8 lg:px-20 mb-24">
            <div className="max-w-4xl mx-auto text-center animate-slide-in-right">
              <h2 className="text-luxury-gold text-4xl lg:text-5xl font-serif font-bold mb-6">
                {historia.titulo}
              </h2>
              {historia.subtitulo && (
                <h3 className="text-white text-2xl font-semibold mb-4">
                  {historia.subtitulo}
                </h3>
              )}
              <p className="text-gray-400 text-base leading-relaxed">
                {historia.descricao}
              </p>
            </div>
          </section>
        )}

        {/* Estatísticas */}
        <section className="px-8 lg:px-20">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {(estatisticas?.dados_json?.items || [
              { numero: '2025', label: 'Fundação' },
              { numero: '50+', label: 'Cursos Premium' },
              { numero: '98%', label: 'Satisfação' },
              { numero: '24/7', label: 'Suporte' },
            ]).map((stat: any, index: number) => (
              <div
                key={index}
                className="text-center animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="text-5xl lg:text-6xl font-black bg-gradient-gold-silver bg-clip-text text-transparent mb-3">
                  {stat.numero}
                </div>
                <p className="text-gray-400 text-sm uppercase tracking-wider">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SobrePage;
